import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
// option picker
import '@vfde-brix/option-picker/dist/styles.css';
// accordion
import '@vfde-brix/accordion/dist/styles.css';
import { createAccordionComponent } from '@vfde-brix/accordion';
// button
import '@vfde-brix/button/dist/styles.css';
import { createButtonComponent } from '@vfde-brix/button';
// helpful
import '@vfde-brix/helpful/dist/styles.css';
import { createHelpfulComponent } from '@vfde-brix/helpful';
// contact us
import '@vfde-brix/contact-us/dist/styles.css';
import { createContactUsComponent } from '@vfde-brix/contact-us';
// feedback
import '@vfde-brix/feedback/dist/styles.css';
import { createFeedbackComponent } from '@vfde-brix/feedback';
// image-text
import '@vfde-brix/image-text/dist/styles.css';
import { createImageTextComponent } from '@vfde-brix/image-text';
// notification
import '@vfde-brix/notification/dist/styles.css';
import { createNotificationComponent } from '@vfde-brix/notification';
// interaction bar
import '@vfde-brix/interaction-bar/dist/styles.css';
import { createInteractionBarComponent } from '@vfde-brix/interaction-bar';
// tabs
import '@vfde-brix/tabs/dist/styles.css';
import { createTabsComponent } from '@vfde-brix/tabs';
// image-slider
import '@vfde-brix/image-slider/dist/styles.css';
import { createImageSliderComponent  } from '@vfde-brix/image-slider';
// media-segment
// include media-segment css
import '@vfde-brix/youtube-video/dist/styles.css';
import '@vfde-brix/video/dist/styles.css';
import '@vfde-brix/image/dist/styles.css';
import '@vfde-brix/button/dist/styles.css';
import '@vfde-brix/headline/dist/styles.css';
import '@vfde-brix/media-segment/dist/styles.css';
import { createMediaSegmentBlock } from '@vfde-brix/media-segment';

// dkm
import '@vfde-brix/dynamic-click-module/dist/styles.css';
import {createDynamicClickModuleComponent } from '@vfde-brix/dynamic-click-module';

// helper function for below
const initPattern = (createFunction: any, className: string) => {
    const elements = document.getElementsByClassName(className);
    for (let i = 0, x = elements.length; i < x; i += 1) {
        const containerElement = elements[i].parentElement;
        createFunction(containerElement, NO_PATTERN_BUSINESS_LOGIC);
    }
};

// init acc
initPattern(createAccordionComponent, 'brix-accordion');
// init button
initPattern(createButtonComponent, 'brix-button');
// helpful
initPattern(createHelpfulComponent, 'brix-helpful');
// contact us
initPattern(createContactUsComponent, 'brix-contact-us');
// feedback
initPattern(createFeedbackComponent, 'brix-feedback');
// image text
initPattern(createImageTextComponent, 'brix-image-text');
// notification
initPattern(createNotificationComponent, 'brix-notification');
// interaction bar
initPattern(createInteractionBarComponent, 'brix-interaction-bar');
// tabs
initPattern(createTabsComponent, 'brix-tabs');
// image-slider
initPattern(createImageSliderComponent, 'brix-image-slider');
// media-segment
initPattern(createMediaSegmentBlock, 'brix-media-segment');
// init dcm
// initPattern(createDynamicClickModuleComponent, 'brix-dcm');
createDynamicClickModuleComponent(
    document.getElementById('brix-dcm'),
    NO_PATTERN_BUSINESS_LOGIC,
);
